import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import DownloadIcon from '@mui/icons-material/Download';
import * as XLSX from 'xlsx';
import '../shared.css';

const StockTransferDetails = () => {
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, token, logout } = useAuth();

    const [formData, setFormData] = useState({});
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [selectedBranch, setSelectedBranch] = useState('');
    const [dropdownBranchOptions, setDropdownBranchOptions] = useState([]);
    const [BranchData, setBranchData] = useState([]);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    useEffect(() => {
        fetchData('StockTransferApi', `/StockTransferBranch/${companyId}/${branchId}`, token)
            .then(r => { setDropdownBranchOptions(r.response_data); setBranchData(r.response_data); })
            .catch(console.error);
    }, []);

    useEffect(() => {
        fetchData('StockTransferApi', `/${id}`, token)
            .then(r => {
                if (r.responseCode === '1111') {
                    setFormData(r.response_data.StockTransfer);
                    setInvoicedeatils(r.response_data.StockTransferDetails);
                    setSelectedBranch(r.response_data.StockTransfer.ToBranchId);
                }
            }).catch(console.error);
    }, [id]);

    const fmt = (d) => { if (!d) return ''; const dt = new Date(d); return `${dt.getFullYear()}-${String(dt.getMonth()+1).padStart(2,'0')}-${String(dt.getDate()).padStart(2,'0')}`; };
    const fmtVal = (v) => v != null ? parseFloat(v).toFixed(2) : '0.00';

    const handleDownloadExcel = () => {
        const filteredData = invoicedeatils.map((item, index) => ({
            SlNo: index + 1, ItemName: item.ItemName, Quantity: item.Quantity, Rate: item.Rate, TotalAmount: item.TotalAmount
        }));
        const selectedBranchData = BranchData.find(b => b.Id == selectedBranch);
        const worksheet = XLSX.utils.json_to_sheet(filteredData, { origin: 'A5' });
        XLSX.utils.sheet_add_aoa(worksheet, [['Stock Transfer To ' + (selectedBranchData?.Name || '')]], { origin: 'A1' });
        XLSX.utils.sheet_add_aoa(worksheet, [['Stock Transfer No: ' + formData.BillPrefix + '/S/' + formData.BillNumber + '/' + formData.FinYear]], { origin: 'A3' });
        XLSX.utils.sheet_add_aoa(worksheet, [['Date: ' + fmt(formData.BillDate)]], { origin: 'C3' });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'StockTransferDetails');
        XLSX.writeFile(workbook, `StockTransferDetails_${id}.xlsx`);
    };

    const title = formData.InputRejected ? 'Stock Transfer Out - Details (Rejected)' : 'Stock Transfer Out - Details';

    return (
        <Fragment>
            <div className="pg-container">
                <div className="pg-header">
                    <h5 className="pg-title">{title}</h5>
                    <div className="pg-header-actions">
                        <div className="pg-action-row">
                            <button className="pg-btn pg-btn-outline" onClick={handleDownloadExcel}><DownloadIcon /> Excel</button>
                            <Link to="/StockTransferIndex" className="pg-btn pg-btn-danger"><CloseIcon /> Back to List</Link>
                        </div>
                    </div>
                </div>

                <div className="pg-card">
                    <div className="pg-hpanel">
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">To Branch</span>
                            <select className="pg-hcell-select" value={selectedBranch} disabled>
                                <option value="">Select Branch</option>
                                {dropdownBranchOptions.map(b => <option key={b.Id} value={b.Id}>{b.Name}</option>)}
                            </select>
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Date</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="date" value={fmt(formData.BillDate)} disabled />
                        </div>
                        <div className="pg-hcell" style={{ flex: '1 1 0' }}>
                            <span className="pg-hcell-label">Bill Number</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.BillNumber || ''} readOnly />
                        </div>
                        <div className="pg-hcell" style={{ flex: '0 0 90px' }}>
                            <span className="pg-hcell-label">Total Qty</span>
                            <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={formData.TotalQuantity || ''} readOnly />
                        </div>
                    </div>

                    <div className="pg-invoice-table-wrap" style={{ marginTop: 12 }}>
                        <table className="pg-invoice-table">
                            <thead><tr><th>#</th><th>Item Name</th><th className="right">Qty</th><th className="right">Rate</th><th className="right">Amount</th></tr></thead>
                            <tbody>
                                {invoicedeatils.length === 0
                                    ? <tr><td colSpan={5} style={{ textAlign: 'center', color: '#94a3b8', padding: 14 }}>No items found.</td></tr>
                                    : invoicedeatils.map((item, i) => (
                                        <tr key={i}>
                                            <td style={{ textAlign: 'center', width: 40 }}>{i + 1}</td>
                                            <td>{item.ItemName}</td>
                                            <td className="right">{item.Quantity}</td>
                                            <td className="right">{fmtVal(item.Rate)}</td>
                                            <td className="right" style={{ fontWeight: 700 }}>{fmtVal(item.TotalAmount)}</td>
                                        </tr>
                                    ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="pg-hpanel" style={{ marginTop: 8 }}>
                        <div className="pg-hcell" style={{ flex: '3 1 0' }}>
                            <span className="pg-hcell-label">Remarks</span>
                            <input className="pg-hcell-input pg-hcell-readonly" type="text" value={formData.Remarks || ''} readOnly />
                        </div>
                        {[['Amount', 'TaxableAmount'], ['CGST', 'CGSTAmount'], ['SGST', 'SGSTAmount'], ['IGST', 'IGSTAmount'], ['Round Off', 'RoundOff'], ['Grand Total', 'GrandTotal']].map(([label, key]) => (
                            <div key={key} className="pg-hcell" style={{ flex: '1 1 0' }}>
                                <span className="pg-hcell-label">{label}</span>
                                <input className="pg-hcell-input pg-hcell-readonly text-right" type="text" value={fmtVal(formData[key])} readOnly />
                            </div>
                        ))}
                    </div>
                </div>

                <div className="pg-watermark"><CopyrightIcon style={{ fontSize: 12 }} /><b>EFFTABS SOLUTIONS LLP</b></div>
            </div>
        </Fragment>
    );
};

export default StockTransferDetails;
